(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) {
    root.NBBBlogCommerceAnalytics = api;
    var boot = function () {
      if (root.document && root.NBBAnalytics) api.create(root.document, { analytics: root.NBBAnalytics });
    };
    if (root.document && root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', boot);
    else boot();
  }
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  var STORAGE_KEY = 'nbb_blog_commerce_touch_v1';
  var STORAGE_TTL_MS = 30 * 24 * 60 * 60 * 1000;
  var QUALIFIED_VIEW_MS = 1000;

  function create(doc, dependencies) {
    if (!doc) return null;
    dependencies = dependencies || {};
    var win = doc.defaultView || {};
    var analytics = dependencies.analytics || win.NBBAnalytics;
    var Observer = dependencies.IntersectionObserver || win.IntersectionObserver;
    var storage = dependencies.storage || win.localStorage;
    var fetcher = dependencies.fetch || (win.fetch && win.fetch.bind(win));
    var now = dependencies.now || Date.now;
    var setTimer = dependencies.setTimeout || (win.setTimeout && win.setTimeout.bind(win)) || setTimeout;
    var clearTimer = dependencies.clearTimeout || (win.clearTimeout && win.clearTimeout.bind(win)) || clearTimeout;
    var blocks = Array.prototype.slice.call(doc.querySelectorAll('[data-nbb-commerce-block]'));
    var articleRoot = doc.querySelector('[data-article-body], .main-article--body, .article__content, .rte');
    var articleBlock = blocks[0] || null;
    var viewTimers = new Map();
    var viewed = new Set();
    var readMilestones = new Set();

    function payloadFor(block) {
      return {
        article_handle: block.dataset.articleHandle || '',
        blog_type: block.dataset.blogType || 'informational',
        block_type: block.dataset.block || '',
        block_slot: block.dataset.blockSlot || block.dataset.pos || '',
        page_type: 'article',
        locale: doc.documentElement.lang || ''
      };
    }

    function publish(name, payload) {
      if (analytics && typeof analytics.publish === 'function') analytics.publish(name, payload);
    }

    function articlePayload() {
      return {
        article_handle: articleBlock && articleBlock.dataset.articleHandle || '',
        blog_type: articleBlock && articleBlock.dataset.blogType || 'informational',
        page_type: 'article',
        locale: doc.documentElement.lang || ''
      };
    }

    if (articleBlock) publish('blog_article_viewed', articlePayload());

    function defaultReadProgress() {
      if (!articleRoot || !articleRoot.getBoundingClientRect) return 0;
      var rect = articleRoot.getBoundingClientRect();
      var height = Math.max(articleRoot.scrollHeight || rect.height || 0, 1);
      var viewportHeight = Number(win.innerHeight) || 0;
      return Math.max(0, Math.min(1, (viewportHeight - rect.top) / height));
    }

    var readProgress = dependencies.readProgress || defaultReadProgress;
    function onScroll() {
      var progress = Number(readProgress());
      [25, 50, 75, 90].forEach(function (milestone) {
        if (progress * 100 < milestone || readMilestones.has(milestone)) return;
        readMilestones.add(milestone);
        var payload = articlePayload();
        payload.read_depth = milestone;
        publish('blog_read_progress', payload);
      });
    }
    if (articleBlock && win.addEventListener) win.addEventListener('scroll', onScroll, { passive: true });

    function cancelViewTimer(block) {
      if (!viewTimers.has(block)) return;
      clearTimer(viewTimers.get(block));
      viewTimers.delete(block);
    }

    var observer = Observer ? new Observer(function (entries) {
      entries.forEach(function (entry) {
        var block = entry.target;
        if (viewed.has(block)) return;
        if (!entry.isIntersecting || entry.intersectionRatio < 0.5) {
          cancelViewTimer(block);
          return;
        }
        if (viewTimers.has(block)) return;
        var timer = setTimer(function () {
          viewTimers.delete(block);
          if (viewed.has(block)) return;
          viewed.add(block);
          publish('blog_block_viewed', payloadFor(block));
          if (observer && typeof observer.unobserve === 'function') observer.unobserve(block);
        }, QUALIFIED_VIEW_MS);
        viewTimers.set(block, timer);
      });
    }, { threshold: [0, 0.5, 1] }) : null;

    if (observer) blocks.forEach(function (block) { observer.observe(block); });

    function readTouch() {
      try {
        var value = JSON.parse(storage.getItem(STORAGE_KEY) || 'null');
        if (!value || !Number.isFinite(value.touchedAt) || now() - value.touchedAt > STORAGE_TTL_MS) return null;
        return value;
      } catch (_error) {
        return null;
      }
    }

    function writeTouch(first, last) {
      try { storage.setItem(STORAGE_KEY, JSON.stringify({ first: first, last: last, touchedAt: now() })); }
      catch (_error) {}
    }

    function touchValue(payload) {
      return ['blog', payload.article_handle || 'unknown', payload.blog_type || 'informational',
        payload.block_type || 'unknown', payload.block_slot || 'unknown',
        payload.destination_type || 'unknown', payload.destination_handle || 'unknown'].join('|').slice(0, 200);
    }

    function carryToCart(first, last) {
      if (!fetcher) return;
      Promise.resolve(fetcher('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        keepalive: true,
        body: JSON.stringify({ attributes: { nbb_first_touch: first, nbb_last_touch: last } })
      })).catch(function () {});
    }

    function onClick(event) {
      var destination = event.target.closest && event.target.closest('[data-nbb-destination]');
      var block = destination && destination.closest('[data-nbb-commerce-block]');
      var payload;
      if (block && doc.documentElement.contains(block)) {
        payload = payloadFor(block);
        payload.destination_type = destination.dataset.destinationType || '';
        payload.destination_handle = destination.dataset.destinationHandle || '';
        publish('blog_block_clicked', payload);
      } else {
        var anchor = event.target.closest && event.target.closest('a[href]');
        if (!anchor || !articleRoot || !articleRoot.contains(anchor)) return;
        var url;
        try { url = new URL(anchor.href, win.location && win.location.href); }
        catch (_error) { return; }
        if (!win.location || url.origin !== win.location.origin) return;
        var match = url.pathname.match(/^\/(products|collections)\/([a-z0-9][a-z0-9-]*)\/?$/i);
        if (!match) return;
        payload = articlePayload();
        payload.block_type = 'organic-link';
        payload.block_slot = 'body';
        payload.destination_type = match[1] === 'products' ? 'product' : 'collection';
        payload.destination_handle = match[2];
        publish('blog_commerce_link_clicked', payload);
      }

      var current = readTouch();
      var last = touchValue(payload);
      var first = current ? current.first : last;
      writeTouch(first, last);
      carryToCart(first, last);
    }

    doc.addEventListener('click', onClick);
    return {
      destroy: function () {
        doc.removeEventListener('click', onClick);
        if (win.removeEventListener) win.removeEventListener('scroll', onScroll);
        viewTimers.forEach(function (timer) { clearTimer(timer); });
        viewTimers.clear();
        if (observer && typeof observer.disconnect === 'function') observer.disconnect();
      }
    };
  }

  return { create: create };
});
